import React from 'react';
import { about } from '../../models/content';
import V2CtaDark from '../components/V2CtaDark';

export default function V2AboutPage() {
  return (
    <>
      <main>
        <section className="page-hero">
          <div className="wrap">
            <span className="v2-badge">
              <span className="dot" />
              {about.heroBadge}
            </span>
            <h1>
              {about.heroTitle.map((p, i) =>
                typeof p === 'string' ? (
                  <React.Fragment key={i}>{p}</React.Fragment>
                ) : (
                  <span key={i} className="it">
                    {p.it}
                  </span>
                )
              )}
            </h1>
            <p className="sub">{about.heroSub}</p>
          </div>
        </section>

        <section>
          <div className="wrap">
            <div className="prose">
              {about.paragraphs.map((p) => (
                <p key={p}>{p}</p>
              ))}
              <p className="lift">{about.lift}</p>
            </div>
          </div>
        </section>
      </main>

      <V2CtaDark />
    </>
  );
}

